export const SET_USER = "SET_USER";
export const USER_LOADED = "USER_LOADED";
export const REMOVE_USER = "REMOVE_USER";
